import Cookies from 'js-cookie';

/**
 * Checks if the user is logged in by checking the profiles cookie.
 * @returns {boolean} True if the user is logged in, false otherwise.
 */
export function isUserLoggedIn(): boolean {
  const profilesCookie = Cookies.get('_profiles_user');
  return profilesCookie && profilesCookie !== 'none';
}
